import { Link } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { useSeo } from '@/seo/useSeo'
// Not the full GUIDES array (@/data/seo/guides) — see the comment in
// @/data/homeIndex for why importing it here would eagerly load the whole
// guide content chunk on the one page that renders unavoidably
// eagerly for any broken/unknown URL.
import { FEATURED_GUIDES } from '@/data/homeIndex'

export const NotFoundPage = () => {
  useSeo()
  return (
    <Layout>
      <div className="py-12 text-center">
        <p className="text-6xl font-bold opacity-20">404</p>
        <h1 className="mt-4 text-3xl font-bold">That page does not exist</h1>
        <p className="mx-auto mt-3 max-w-md opacity-80">
          It may have moved, or the link may be wrong. The tools and guides below are the most-visited
          parts of the site.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link to="/resume-builder" className="btn btn-primary">
            Open the builder
          </Link>
          <Link to="/ats-resume-checker" className="btn btn-outline">
            ATS checker
          </Link>
          <Link to="/guides" className="btn btn-outline">
            All guides
          </Link>
        </div>

        <div className="mx-auto mt-10 grid max-w-2xl gap-2 text-left sm:grid-cols-2">
          {FEATURED_GUIDES.slice(0, 6).map((guide) => (
            <Link
              key={guide.slug}
              to={`/guides/${guide.slug}`}
              className="rounded-box border border-base-300 bg-base-100 p-3 hover:border-primary"
            >
              <p className="text-sm font-medium">{guide.h1}</p>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default NotFoundPage
